<template>
    <div class="animated fadeIn master-form-page">
        <!-- Back Button -->
        <div class="mb-3">
            <button type="button" class="btn btn-back" @click="$router.go(-1)">
                <i class="fa fa-chevron-left mr-1"></i> Back
            </button>
        </div>

        <div class="master-form-card">
            <h4 class="form-page-title">Input Cabang</h4>

            <b-form @submit.prevent="openModalConfirm">
                <!-- DATA CABANG -->
                <div class="form-section-block">
                    <div class="form-section-header no-border">
                        <span class="section-accent-bar"></span>
                        <span class="section-label">DATA CABANG</span>
                    </div>

                    <b-row>
                        <b-col md="6" class="form-field-group">
                            <label class="field-label" for="inputKodeCabang">Kode Cabang</label>
                            <b-form-input 
                                id="inputKodeCabang"
                                v-model="input.kodeCabang" 
                                name="kodeCabang" 
                                :state="kodeCabangState" 
                                :maxlength="4" 
                                placeholder="Contoh: JKT1"
                                class="field-input w-100"
                                required
                            ></b-form-input>
                        </b-col>

                        <b-col md="6" class="form-field-group">
                            <label class="field-label" for="inputNamaCabang">Nama Cabang</label>
                            <b-form-input 
                                id="inputNamaCabang"
                                v-model="input.namaCabang" 
                                name="namaCabang" 
                                type="text" 
                                placeholder="Nama Cabang"
                                class="field-input w-100"
                                required
                            ></b-form-input>
                        </b-col>

                        <b-col md="6" class="form-field-group">
                            <label class="field-label" for="inputNoTelpCabang">No.Telp Cabang</label>
                            <b-form-input 
                                id="inputNoTelpCabang"
                                v-model="input.noTelpCabang" 
                                name="noTelpCabang"
                                placeholder="021-..."
                                class="field-input w-100"
                            ></b-form-input>
                        </b-col>

                        <b-col cols="12">
                            <LokasiCabang v-model="input.lokasi" />
                        </b-col>

                        <b-col cols="12" class="form-field-group">
                            <label class="field-label" for="inputAlamatCabang">Alamat Cabang</label>
                            <b-form-textarea 
                                id="inputAlamatCabang"
                                v-model="input.alamatCabang" 
                                name="alamatCabang" 
                                rows="3" 
                                placeholder="Alamat lengkap cabang..."
                                class="field-input w-100 h-auto"
                                required
                            ></b-form-textarea>
                        </b-col>

                        <b-col md="6" class="form-field-group">
                            <label class="field-label" for="selectSkemaPerhitungan">Skema Perhitungan</label>
                            <b-form-select 
                                id="selectSkemaPerhitungan"
                                v-model="input.skemaPerhitungan" 
                                name="skemaPerhitungan" 
                                :options="skemaOption" 
                                value-field="id" 
                                text-field="name" 
                                class="field-select w-100"
                                required
                            > 
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>-- Pilih Skema Perhitungan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>

                        <b-col md="6" class="form-field-group">
                            <label class="field-label" for="inputIpAddress">Alamat IP Cabang</label>
                            <b-form-input 
                                id="inputIpAddress"
                                v-model="input.ipAddress" 
                                max="20" 
                                name="ipAddress"
                                placeholder="Contoh: 36.121.33.211"
                                class="field-input w-100"
                            ></b-form-input>
                            <small class="text-muted d-block mt-1">
                                Alamat IP untuk WiFi pada cabang (Digunakan untuk pengecekan akses user). Contoh: 36.121.33.211
                            </small>
                        </b-col>

                        <b-col md="6" class="form-field-group">
                            <label class="field-label" for="inputLatitude">Latitude</label>
                            <b-form-input 
                                id="inputLatitude"
                                v-model="input.latitude" 
                                max="15" 
                                name="latitude"
                                placeholder="Contoh: -6.2088"
                                class="field-input w-100"
                            ></b-form-input>
                            <small class="text-muted d-block mt-1">
                                Latitude cabang (sebagai contoh, -82.28182)
                            </small>
                        </b-col>

                        <b-col md="6" class="form-field-group">
                            <label class="field-label" for="inputLongitude">Longitude</label>
                            <b-form-input 
                                id="inputLongitude"
                                v-model="input.longitude" 
                                max="15" 
                                name="longitude"
                                placeholder="Contoh: 106.8456"
                                class="field-input w-100"
                            ></b-form-input>
                            <small class="text-muted d-block mt-1">
                                Longitude cabang (sebagai contoh, 12.99782)
                            </small>
                        </b-col>
                    </b-row>
                </div>

                <!-- Actions Footer -->
                <div class="form-actions-footer">
                    <button type="submit" name="cabangSubmitBtn" class="btn btn-submit" :disabled="isSubmitting">
                        Kirim
                    </button>
                    <button type="button" class="btn btn-cancel" @click="$router.go(-1)">
                        Batal
                    </button>
                </div>
            </b-form>
        </div>

        <ModalConfirm 
            id="modal-confirm-input" 
            title="Confirm Input Cabang" 
            :isSubmitting="isSubmitting" 
            desc="Apakah anda yakin untuk menginput cabang ini?" 
            @submit="onSubmit" 
        />
    </div>
</template>

<script>
import LokasiCabang from '../../../components/cabang/LokasiCabang'

export default {
    name: 'input-cabang',
    components: { LokasiCabang },
    data(){
        return{
            isSubmitting: false,
            input:{
                kodeCabang: null,
                namaCabang: "",
                alamatCabang: "",
                lokasi: { provinsi: null, kota: null, kecamatan: null, kelurahan: null },
                noTelpCabang: null,
                skemaPerhitungan: null,
                latitude: null,
                longitude: null,
                ipAddress: null,
            },
            skemaOption: [
                {id: 1, name: 'Dibelakang'},
                {id: 2, name: 'Didepan'}
            ],
            kodeCabangState: null
        }
    },
    methods:{

        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()

            //----------------- Append Data Cabang -----------------

            payload.append("kode", this.input.kodeCabang)
            payload.append("name", this.input.namaCabang)
            payload.append("alamat", this.input.alamatCabang)
            payload.append("kotaId", this.input.lokasi.kota.id)
            payload.append("kecamatanId", this.input.lokasi.kecamatan.id)
            payload.append("kelurahanId", this.input.lokasi.kelurahan.id)
            if (this.$helper.isNotNullAndNotEmpty(this.input.noTelpCabang)) payload.append("telepon", this.input.noTelpCabang)
            payload.append("skemaPerhitungan", this.input.skemaPerhitungan)
            if(this.$helper.isNotNullAndNotEmpty(this.input.latitude)) payload.append("latitude", this.input.latitude)
            if(this.$helper.isNotNullAndNotEmpty(this.input.longitude)) payload.append("longitude", this.input.longitude)
            if(this.$helper.isNotNullAndNotEmpty(this.input.ipAddress)) payload.append("ipAddress", this.input.ipAddress)
            
            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("cabang/", payload).then(response => {
                this.$helper.setFlash(`Cabang baru telah berhasil dibuat!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/") + `/${response.data.id}`
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if (!this.validKodeCabang(this.input.kodeCabang) || !(this.input.kodeCabang.length == 4)) {
                this.$helper.toastErr(this, "Kode Cabang harus 4 karakter dan alphanumeric")
                this.kodeCabangState = false;
            } 
            else if (!this.input.lokasi.kota || !this.input.lokasi.kecamatan || !this.input.lokasi.kelurahan) {
                this.$helper.toastErr(this, "Tolong lengkapi provinsi, kota, kecamatan, dan kelurahan cabang")
            }
            else if(this.$helper.isNullOrEmpty(this.input.kodeCabang) || this.$helper.isNullOrEmpty(this.input.namaCabang) || this.$helper.isNullOrEmpty(this.input.alamatCabang) || this.$helper.isNullOrEmpty(this.input.noTelpCabang)) {
                this.$helper.toastErr(this, "Tolong lengkapi semua data")
            }else if(this.$helper.isNotNullAndNotEmpty(this.input.latitude) && this.input.latitude.length >15){
                this.$helper.toastErr(this, "Latitude maksimal 15 karakter")
            }else if(this.$helper.isNotNullAndNotEmpty(this.input.longitude) && this.input.longitude.length > 15){
                this.$helper.toastErr(this, "Longitude maksimal 15 karakter")
            }else if(this.$helper.isNotNullAndNotEmpty(this.input.ipAddress) && this.input.ipAddress.length> 20){
                this.$helper.toastErr(this, "Alamat IP Cabang maksimal 20 karakter")
            }
            else {
                this.kodeCabangState = true;
                this.$bvModal.show("modal-confirm-input")
            }
        },

        validKodeCabang(kodeCabang){
            var re = /^[0-9a-zA-Z]+$/;
            return re.test(kodeCabang);
        }

    },
}
</script>
